import { render, staticRenderFns } from "./runSheetTaxTab.vue?vue&type=template&id=5b841e96&scoped=true"
import script from "./runSheetTaxTab.vue?vue&type=script&lang=js"
export * from "./runSheetTaxTab.vue?vue&type=script&lang=js"
import style0 from "./runSheetTaxTab.vue?vue&type=style&index=0&id=5b841e96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b841e96",
  null
  
)

export default component.exports